import { Box, Spinner, VStack } from '@chakra-ui/react'
import React from 'react'

const Loader = () => {
  return (
    <>
    <VStack h="90vh" justifyContent={"center"}>
   <Box transform={"scale(3)"}>
    <Spinner size={"xl"}/>
   </Box>
   <Box margin={"1.5"}>
   <h1> Loading please wait...</h1>
   </Box>
    </VStack>
    
    </>
  )
}

export default Loader
